'use client'

import { BetterSleepDrawers, CompareHeroConnected, EasilyCooling, PersonalizedSleep, SleepCoolAllNightConnected } from 'pageCores/prospectingCMin/localComponents'
import { FeaturedReviews } from 'components/Phantom/_sections/FeaturedReviews'
import { MiniShopConnected } from 'pageCores/prospectingBJulia/localComponents'
import { TruemedIntraPageComponentConnected } from 'components/TruemedIntraPageComponent'
import { Benefits } from 'components/Phantom/_sections/ScrollSequenceStatic'
import * as React from 'react'
import { Compare } from './localComponents/Compare'

export const PodCompare = () => {
	return (
		<>
			<CompareHeroConnected />
			<Compare />
			<EasilyCooling />
			<SleepCoolAllNightConnected />
			<BetterSleepDrawers />
			<PersonalizedSleep />
			<FeaturedReviews />
			<MiniShopConnected />
			<TruemedIntraPageComponentConnected />
			<Benefits />
		</>
	)
}
